import { VehicleSetup } from 'contracts/VehicleSetups';
import { useAuth } from 'hooks/auth';
import { api } from 'services/api';

export function useVehicleSetup() {
  const { token } = useAuth();
  const getVehicleSetups = async (id: string): Promise<VehicleSetup[]> => {
    const { data } = await api.get(
      `/vehicle-setups?asList=1&excludeBlocked=true&warehouseId=${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return data;
  };

  return { getVehicleSetups };
}
